import { AppConfig } from './../../../../../environments/appconfig';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FiltroCoSeguimientoPedido } from '../../../comercial/seguimiento/dominio/FiltroCoSeguimientoPedido';
import { DtoCoDocumentoCobrar } from '../../../comercial/codocumento/dominio/DtoCoDocumentoCobrar';
import { UHttpsClient } from '../../../../seguridad/seguridad/uhttpsClient';

@Injectable()
export class WhGuiaService {
    private url = `${this.config.getEnv('proxy')}spring/logistica/whguiaremision/`;
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(private http: UHttpsClient, private config: AppConfig) { }

    public listarGuiasPaginacion(filtro: FiltroCoSeguimientoPedido): Promise<DtoCoDocumentoCobrar[]> {
        return this.http.post(`${this.url}listarGuiasPaginacion`, filtro,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as DtoCoDocumentoCobrar[];
            })
            .catch(error => []);
    }
}
